import { createReducer } from 'redux-act';

import { initMarketplace } from './settings.actions';

export interface ISettingsState {
  isInit: boolean;
  hashId: string;
  isDonation: boolean;
}

export const initialState: ISettingsState = {
  isInit: false,
  hashId: '',
  isDonation: false,
};

const reducer = createReducer<ISettingsState>({}, initialState);

reducer.on(initMarketplace, (state, payload) => ({
  ...state,
  isInit: true,
  hashId: payload.hashId,
  isDonation: payload.isDonation,
}));

export default reducer;
